import { Box, Flex } from '@rango-dev/whale';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { DEFAULT_LANGUAGE } from '../../constants/i18n';
import { useAppSelector } from '../../hooks/reduxHooks';

// Flip this on to swap in the seasonal logo across the app.
const IS_CHRISTMAS_HOLIDAY = false;

function getLogoSrc(isDarkMode: boolean): string {
  const suffix = isDarkMode ? '-dark' : '';
  return IS_CHRISTMAS_HOLIDAY
    ? `/imgs/logos/christmas-logo${suffix}.png`
    : `/imgs/logos/LogoWithText${suffix}.svg`;
}

export const Logo = () => {
  const { isDarkMode, language } = useAppSelector((state) => state.settings);

  useEffect(() => {
    // Preload both themes' logos so toggling dark mode doesn't flash.
    [getLogoSrc(true), getLogoSrc(false)].forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const logoSrc = getLogoSrc(isDarkMode);

  return (
    <Flex position="relative">
      <Link id="header-logo-image-btn" to={language === DEFAULT_LANGUAGE ? '/' : `/${language}`}>
        <Box>
          <Box
            asChild
            display={{ initial: 'none', sm: 'inline-block' }}
            width="110px"
            height="40px">
            <img src={logoSrc} alt="Logo" />
          </Box>
          <Box display={{ initial: 'block', sm: 'none' }}>
            <img src={logoSrc} alt="Logo" width="76px" height="28px" />
          </Box>
        </Box>
      </Link>
    </Flex>
  );
};
